import * as types from './mutation-types'

export default {
  [types.ON_RECEIVE_CITIES] (state, payload) {
    if (payload.cities && Array.isArray(payload.cities)) {
      state.all.cities = payload.cities.sort((a, b) => a[`name_${payload.lang}`].localeCompare(b[`name_${payload.lang}`]))
    } else {
      state.all.cities = []
    }
  },
  [types.ON_RECEIVE_COUNTRIES] (state, payload) {
    if (payload.countries && Array.isArray(payload.countries)) {
      state.all.countries = payload.countries.sort((a, b) => a[`name_${payload.lang}`].localeCompare(b[`name_${payload.lang}`]))
    } else {
      state.all.countries = []
    }
  }
}
